import { $, $$, alcance, aviso, avisoHtml, el, esc, escribir, fecha, limpiar, noContesto, num, pedir, puede, repintar, rpc, sb, pedirTodo, ordenarPor, YO } from './nucleo';
import { puertaPedido } from './pedidos';
import { irACobros } from './cobros';
import { abrirVenta } from './venta';
import { irACuenta } from './cuentas';
import { abrirComoFicha, cerrarComoFicha } from './navegacion';

let CLIENTES = [];
//  Lo que NO se pudo leer de `v_clientes`. Sin esta bandera, una caída dejaba
//  el select del pedido pelado y "Confirmar" vivo, con el aviso en una pestaña
//  oculta. La puerta que cierra vive en `pedidos.ts` (dueño del botón).
export let ERROR_CLIENTES = '';
//  El motivo del bloqueo, por cliente. Vive en `cliente_eventos`, que desde la
//  0043 sólo lee quien puede bloquear: por eso se pide aparte.
let MOTIVOS = {};

// ---------- clientes ----------
let VENDEDORES = [];

//  LAS ZONAS. Llenan el `<select>` del alta de cliente y viven acá porque acá
//  está ese select (regla 1 del README: el estado lo escribe su dueño). Si
//  dependieran de `pedido.ver`, quien tiene `cliente.ver` sin él daría altas
//  con la zona vacía, y la zona decide el reparto (D49).
//
//  `zonas` no se tapa por permiso (su RLS es `app.es_usuario()`): un `error`
//  es una falla de verdad.
export let ERROR_ZONAS = '';
let ZONAS_LEIDAS = false;
let ZONAS: { id: number; nombre: string }[] = [];
//  Para la ficha de la venta (D220), que edita la zona del envío.
export const zonasLeidas = () => ZONAS;

//  Acá NO se cierra ninguna puerta, a propósito: `clientes.zona_id` es nulable
//  y un alta sin zona es legítima (regla 11). Lo que hace falta es que nadie
//  elija "sin zona" creyendo que no hay zonas: el select lo dice y el cartel
//  lo explica.
export async function cargarZonas(){
  //  Se marca ANTES del `await`: dos clicks rápidos lanzarían dos lecturas.
  ZONAS_LEIDAS = true;
  const { data, error } = await pedir(sb.from('zonas')
    .select('id,nombre').eq('activo',true).order('orden'));
  ERROR_ZONAS = error ? error.message : '';
  ZONAS = error ? [] : ((data || []) as any);
  if (FICHA) pintarZonaFicha();
  repintar('#cZona', ERROR_ZONAS
    ? '<option value="">Sin zona — no se pudieron leer</option>'
    : '<option value="">Sin zona</option>' +
      (data||[]).map(z => `<option value="${z.id}">${esc(z.nombre)}</option>`).join(''));
  if (ERROR_ZONAS)
    avisoHtml('#cliZonaMsg', 'bad',
      `No se pudieron leer las zonas (${esc(ERROR_ZONAS)}). <b>No es que no haya ` +
      'ninguna: es que no se pudieron leer.</b> El alta sigue abierta, pero el ' +
      'cliente va a quedar sin zona y la zona es la que después decide el ' +
      'reparto. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
  else limpiar('#cliZonaMsg');
}

//  Al abrir la pestaña, y SÓLO al abrirla: se leen la primera vez y se
//  reintentan si falló (es un catálogo que no cambia). Vive acá y no en
//  `entrar()` para que decida el permiso de esta pestaña y no `pedido.ver`.
//  Devuelve la lectura en viaje (o nada, si ya estaban): la ficha de la
//  venta (D220) repinta su zona cuando llegan.
let LEYENDO_ZONAS: Promise<void> = Promise.resolve();
export function asegurarZonas(){
  if (!ZONAS_LEIDAS || ERROR_ZONAS) LEYENDO_ZONAS = cargarZonas();
  return LEYENDO_ZONAS;
}

export async function cargarClientes(){
  const { data, error } = await pedirTodo(() => sb.from('v_clientes')
    .select('id,nombre,telefono,zona,es_comisionista,activo,vendedor_id,vendedor,tiene_cuenta_corriente,limite_credito,cc_sin_tope,bloqueado_para_reservas')
    .eq('activo', true), { por: 'id', orden: ordenarPor('nombre', 'id') });
  //  El error no se traga (regla del 4/9): sin aviso parecería "no hay
  //  clientes". Esta función corre TAMBIÉN al abrir Pedidos, donde `#cliMsg` no
  //  se ve: por eso hay bandera, el select lo dice y la puerta se cierra.
  ERROR_CLIENTES = error ? error.message : '';
  CLIENTES = data || [];
  if (error){
    //  Ojo: limpiar acá también el cartel de los motivos; este camino sale por
    //  el `return` sin leer `cliente_eventos` y quedaría pegado uno viejo. Todo
    //  camino que repinta necesita su `else limpiar`.
    limpiar('#bloqLeerMsg');
    aviso('#cliMsg','bad','No pude leer los clientes: ' + error.message);
    //  La tabla de esta pestaña también afirma, así que también se desdice.
    $('#tblClientes').innerHTML = `<tr><td colspan="7" class="vacio">` +
      `No se pudieron leer los clientes (${esc(error.message)}). ` +
      `No quiere decir que no haya ninguno.</td></tr>`;
    repintar('#peCliente', '<option value="">no se pudieron leer los clientes</option>');
    puertaPedido();
    return;
  }

  // Reasignar es cosa del admin, así que la lista de vendedores sale de
  // v_usuarios, que ya es sólo para quien gestiona usuarios.
  if (puede('usuario','gestionar') && !VENDEDORES.length){
    const { data: us, error: e1 } = await pedir(sb.from('v_usuarios').select('id,nombre,roles,activo'));
    if (e1) aviso('#cliMsg','bad','No pude leer la lista de vendedores: ' + e1.message);
    VENDEDORES = (us||[]).filter(u => u.activo && (u.roles||[]).includes('vendedor'));
  }
  //  El permiso se pregunta ANTES de consultar: el RLS no devuelve error sino
  //  lista vacía, y "no me dejan mirar" parecería "no hay ninguno" (regla del 4/9).
  //  Entera (pendiente 38): es la historia de TODOS los bloqueos.
  MOTIVOS = {};
  if (puede('cliente','bloquear')){
    const { data: ev, error: e2 } = await pedirTodo(() => sb.from('cliente_eventos')
      .select('id,cliente_id,tipo,motivo,ocurrido_en')
      .eq('tipo','bloqueo_reservas'), { por: 'id', orden: ordenarPor('-ocurrido_en', '-id') });
    //  El cartel va en `#bloqLeerMsg` y NO en `#bloqMsg`: ahí se dibuja el cuadro
    //  del motivo y el `limpiar` se lo llevaría con lo tecleado cuando
    //  `cargarClientes()` corra de nuevo (igual que `#bloqAviso`).
    if (e2) aviso('#bloqLeerMsg','bad','No pude leer por qué están bloqueados: ' + e2.message);
    //  El primero de cada cliente es el último bloqueo (`pedirTodo` ordena de
    //  nuevo a viejo). El `else limpiar` evita un cartel rojo viejo sobre una
    //  lista que esta vez sí se leyó.
    else { limpiar('#bloqLeerMsg');
           for (const x of (ev || [])) if (!(x.cliente_id in MOTIVOS)) MOTIVOS[x.cliente_id] = x.motivo; }
  }

  //  El select de cliente del pedido:
  //  - Opción vacía primera (regla 10): sin ella queda elegido el primer
  //    cliente y el `if (!$('#peCliente').value)` de `pedidos.ts` es código
  //    muerto (el `required` no frena: "Nuevo pedido" no es un `<form>`).
  //  - `repintar` (regla 12): esta función corre al abrir Pedidos y Clientes y
  //    tras cada alta o reasignación; pisar el `<select>` cambiaba el cliente
  //    en silencio.
  //  - El texto del caso vacío no afirma de más: `v_clientes` filtra por
  //    alcance (`cliente.ver:propio`), así que "no hay ninguno" sería falso.
  repintar('#peCliente', `<option value="">${CLIENTES.length
      ? '— elegí el cliente —' : '— no hay clientes visibles para vos —'}</option>` +
    CLIENTES.map(c => `<option value="${c.id}">${esc(c.nombre)}</option>`).join(''));
  puertaPedido();
  pintarClientes();
  if (FICHA) pintarCuentaFicha();
}

//  La lista negra de reservas (0043). El chip lo ve cualquiera que vea al
//  cliente —le sirve para entender por qué le va a rebotar la reserva—;
//  el motivo y el botón, sólo quien puede bloquear.
function celdaReservas(c){
  const motivo = MOTIVOS[c.id];
  const chip = c.bloqueado_para_reservas
    ? `<span class="chip c-bad"${motivo ? ` title="${esc(motivo)}"` : ''}>bloqueado</span>`
    : '<span class="chip c-ok">libre</span>';
  if (!puede('cliente','bloquear')) return chip;
  return `${chip}
    <button class="b b-sec bloqBtn" data-cliente="${c.id}"
            data-valor="${c.bloqueado_para_reservas ? 'false' : 'true'}"
            data-nombre="${esc(c.nombre)}" style="padding:0.235rem 0.588rem;margin-left:0.353rem">
      ${c.bloqueado_para_reservas ? 'Levantar' : 'Bloquear'}</button>`;
}

function celdaVendedor(c){
  if (!puede('usuario','gestionar'))
    return c.vendedor
      ? esc(c.vendedor)
      : '<span class="chip c-warn">de la casa</span>';
  return `<select data-asignar="${c.id}" style="padding:0.294rem 0.471rem;font-size:.8rem">
      <option value=""${!c.vendedor_id ? ' selected' : ''}>— de la casa —</option>
      ${VENDEDORES.map(v => `<option value="${v.id}"${
        v.id === c.vendedor_id ? ' selected' : ''}>${esc(v.nombre)}</option>`).join('')}
    </select>`;
}

//  Lo que se ve de la cuenta corriente desde la lista de clientes: si fía o
//  no, y hasta cuánto. El saldo vive en su propia pantalla, que es la que
//  tiene el permiso para leerlo.
function chipCuenta(c){
  if (!c.tiene_cuenta_corriente) return '<span class="chip">paga al recibir</span>';
  if (c.cc_sin_tope) return '<span class="chip c-warn">cuenta sin tope</span>';
  const l = Number(c.limite_credito || 0);
  return l > 0
    ? `<span class="chip c-ok">cuenta · hasta ${num(l)}</span>`
    : '<span class="chip c-warn">cuenta · sin límite asignado</span>';
}

function pintarClientes(){
  const q = ($('#buscaCli')?.value || '').toLowerCase();
  const f = CLIENTES.filter(c => !q || c.nombre.toLowerCase().includes(q));
  $('#tblClientes').innerHTML = f.map(c => `
    <tr><td><a href="#" data-ficha="${c.id}"><b>${esc(c.nombre)}</b></a></td>
        <td class="mono">${esc(c.telefono || '—')}</td>
        <td>${esc(c.zona || '—')}</td>
        <td>${c.es_comisionista ? '<span class="chip c-warn">comisionista</span>'
                                : '<span class="chip c-ok">directo</span>'}</td>
        <td>${chipCuenta(c)}</td>
        <td>${celdaReservas(c)}</td>
        <td>${celdaVendedor(c)}</td></tr>
  `).join('') || '<tr><td colspan="7" class="vacio">Todavía no hay clientes visibles para vos</td></tr>';
}

//  Bloquear pide el motivo antes de hacer nada: es obligatorio en la base
//  y es lo que va a leer el que después no pueda reservarle. Levantar no
//  lo pide, porque lo que se borra es el motivo viejo.
$('#tblClientes').onclick = e => {
  const f = el(e.target).closest('[data-ficha]');
  if (f){ e.preventDefault(); abrirFicha(Number(f.dataset.ficha)); return; }
  const b = el(e.target).closest('.bloqBtn');
  if (!b) return;
  pedirBloqueo('#bloqMsg', b);
};

//  El cuadro del motivo vive en la lista (`#bloqMsg`) o en la ficha
//  (`#fcBloqMsg`): uno solo a la vez, porque sus campos llevan los mismos ids.
function pedirBloqueo(dest: string, b: any){
  limpiar('#bloqMsg'); limpiar('#fcBloqMsg');
  const id = Number(b.dataset.cliente), nombre = b.dataset.nombre;
  if (b.dataset.valor === 'false') return bloquear(id, false, null, dest);
  $(dest).innerHTML = `<div class="confirmar">
      <b>Poner a ${esc(nombre)} en la lista negra de reservas</b>
      <div class="hint">De acá en más, reservarle va a pedir una autorización.</div>
      <label>Por qué <input id="bloqMotivo" placeholder="Tres reservas que no vino a buscar"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-pri" id="bloqOk">Bloquear</button>
        <button class="b b-sec" id="bloqNo">Dejarlo como está</button>
      </div>
      <!--  El aviso va ACÁ ADENTRO y no en el contenedor: si no, el propio
            error de "falta el motivo" borra el cuadro donde había que
            escribirlo, y hay que volver a apretar el botón de la fila. -->
      <div id="bloqAviso"></div></div>`;
  $('#bloqNo').onclick = () => limpiar(dest);
  $('#bloqOk').onclick = () => {
    const motivo = ($('#bloqMotivo').value || '').trim();
    if (!motivo){
      aviso('#bloqAviso','bad','Escribí por qué: es lo que va a leer el que después no pueda reservarle.');
      $('#bloqMotivo').focus();
      return;
    }
    bloquear(id, true, motivo, dest);
  };
}

async function bloquear(id, valor, motivo, dest = '#bloqMsg'){
  const { data, error } = await rpc('bloquear_cliente', {
    p_cliente_id: id, p_bloquear: valor, p_motivo: motivo
  });
  //  Si el cuadro está abierto, el error va adentro y el motivo escrito
  //  no se pierde: la base puede rechazar por permiso o por el cliente.
  if (error){ aviso($('#bloqAviso') ? '#bloqAviso' : dest, 'bad', error.message); return; }
  await cargarClientes();
  aviso(dest, 'ok', data?.mensaje || 'Listo.');
  if (FICHA) leerHistorial();
}

$('#tblClientes').onchange = e => reasignar(e, '#cliMsg');

async function reasignar(e, dest: string){
  const sel = el(e.target).closest('[data-asignar]');
  if (!sel) return;
  limpiar(dest);
  const { data, error } = await rpc('asignar_vendedor', {
    p_cliente_id: Number(sel.dataset.asignar),
    p_vendedor_id: sel.value ? Number(sel.value) : null
  });
  if (error){ aviso(dest,'bad', error.message); cargarClientes(); return; }
  aviso(dest,'ok', data.mensaje);
  cargarClientes();
}
$('#buscaCli').oninput = pintarClientes;

$('#formCli').onsubmit = async e => {
  e.preventDefault();
  limpiar('#cliMsg');
  const { error } = await escribir(sb.from('clientes').insert({
    nombre         : $('#cNombre').value.trim(),
    telefono       : $('#cTel').value.trim() || null,
    direccion      : $('#cDir').value.trim() || null,
    barrio         : $('#cBarrio').value.trim() || null,
    email          : $('#cEmail').value.trim() || null,
    zona_id        : $('#cZona').value ? Number($('#cZona').value) : null,
    es_comisionista: $('#cComis').checked
  }));
  //  Si la base no contestó, el cliente quizá quedó dado de alta (D92): lo
  //  tecleado se queda y se relee la lista. Se relee ANTES de avisar:
  //  `cargarClientes` escribe su propio error en `#cliMsg` y pisaría este cartel.
  if (noContesto(error)){
    await cargarClientes();
    aviso('#cliMsg','warn', error.message + (ERROR_CLIENTES
      ? ' Y la lista tampoco se pudo releer: volvé a entrar a la pestaña y ' +
        'buscá al cliente antes de darlo de alta de nuevo.'
      : ' Buscá al cliente en la lista antes de darlo de alta de nuevo.'));
    return;
  }
  if (error){ aviso('#cliMsg','bad', error.message); return; }
  aviso('#cliMsg','ok','Cliente dado de alta.');
  $('#formCli').reset();
  cargarClientes();
};

// =====================================================================
//  LA FICHA DEL CLIENTE (0099, D218)
// =====================================================================
//  Se entra tocando el nombre en la lista. Los datos se guardan por
//  `editar_cliente`, que pide `cliente.editar` con su alcance y deja el
//  historial; si cambian los datos de envío y hay pedidos en curso en moto,
//  la base contesta con la lista y la ficha pregunta a cuáles se les pasan.
//  Se manda SÓLO lo que se cambió respecto de lo que se abrió: si otro
//  cambió otra cosa mientras tanto, no se la pisa con lo viejo.
let FICHA: any = null;
//  Cada apertura lleva su número: la respuesta de una ficha vieja no pinta
//  sobre la de otro cliente.
let TURNO_FICHA = 0;
const TOPE_PED_FICHA = 50;

const CAMPOS_FICHA: [string, string][] = [
  ['nombre', '#fcNombre'], ['documento', '#fcDocumento'], ['telefono', '#fcTel'],
  ['direccion', '#fcDir'], ['piso', '#fcPiso'], ['barrio', '#fcBarrio'],
  ['email', '#fcEmail'], ['notas', '#fcNotas']];

//  La pantalla sólo esconde (D11): quién edita lo decide la base. Esto es
//  para no ofrecer un formulario que la base va a rechazar entero.
const editaFicha = (c: any) => puede('cliente','editar')
  && (alcance('cliente','editar') === 'todos' || c.vendedor_id === YO?.id);

function pintarZonaFicha(){
  const c = FICHA?.datos;
  //  La zona del cliente aunque esté desactivada: si no, quedaría elegida
  //  otra sin que nadie la elija, y se guardaría.
  let html = `<option value="">${ERROR_ZONAS ? 'Sin zona — no se pudieron leer' : 'Sin zona'}</option>` +
    ZONAS.map(z => `<option value="${z.id}">${esc(z.nombre)}</option>`).join('');
  if (c?.zona_id != null && !ZONAS.some(z => z.id === c.zona_id))
    html += `<option value="${c.zona_id}">${esc(FICHA.zona ?? '(zona desactivada)')}</option>`;
  $('#fcZona').innerHTML = html;
  $('#fcZona').value = c?.zona_id == null ? '' : String(c.zona_id);
}

//  La ficha ocupa la pestaña (el alta y la lista se esconden) y vuelve con
//  «← Volver», con el «atrás» del navegador o al cambiar de pestaña (D231).
function mostrarLista(ver: boolean){
  if (ver) cerrarComoFicha($('#fichaCli'));
  else abrirComoFicha($('#fichaCli'), { lista: 'la lista', nombre: 'el cliente',
    boton: $('#fcVolver'), alCerrar: limpiarFicha });
}

function limpiarFicha(){
  FICHA = null;
  TURNO_FICHA++;
  limpiar('#fcBloqMsg');
}
//  También al entrar a la pestaña por el menú (arranque.ts): se llega a la
//  lista, no a la última ficha que quedó abierta.
export function cerrarFicha(){
  limpiarFicha();
  mostrarLista(true);
}

//  Abrir la ficha del cliente desde otra pestaña (la ficha de la vuelta,
//  D233). La cuenta, las reservas y el vendedor salen de la lista: si no se
//  leyó todavía (no se pasó por Clientes), se lee, y al llegar se pintan.
export function abrirClienteDesdeAfuera(id: number){
  const p = abrirFicha(id);
  if (!CLIENTES.some(c => c.id === id)){ asegurarZonas(); cargarClientes(); }
  return p;
}

async function abrirFicha(id: number){
  const turno = ++TURNO_FICHA;
  limpiar('#bloqMsg');
  for (const s of ['#fcMsg', '#fcGuardarMsg', '#fcPedidosEnvio', '#fcBloqMsg', '#fcPedMsg', '#fcHistMsg'])
    limpiar(s);
  $('#fcHist').innerHTML = '';
  $('#tblFcPedidos').innerHTML = '';
  const fila = CLIENTES.find(c => c.id === id);
  FICHA = { id, fila, datos: null, zona: fila?.zona ?? null };
  $('#fcTitulo').textContent = fila?.nombre ?? 'Cliente';
  $('#fcChips').innerHTML = '';
  $('#formFc').classList.add('oculto');
  mostrarLista(false);
  window.scrollTo({ top: 0 });
  asegurarZonas();

  //  Lo que la lista no trae (documento, piso, email, notas) sale de
  //  `clientes`, con el mismo RLS que la lista.
  const { data, error } = await pedir(sb.from('clientes')
    .select('id,nombre,documento,telefono,email,direccion,piso,barrio,zona_id,notas,es_comisionista,vendedor_id')
    .eq('id', id));
  if (turno !== TURNO_FICHA) return;
  if (error){
    //  Abrirla sin lo que el cliente tiene sería guardar sobre datos que no
    //  se ven (D79): el formulario no aparece.
    aviso('#fcMsg', 'bad', `No se pudieron leer los datos del cliente (${error.message}). ` +
      'Volvé a la lista y entrá de nuevo, o recargá con Ctrl+F5.');
    return;
  }
  const c = (data || [])[0];
  if (!c){
    aviso('#fcMsg', 'warn', 'Este cliente ya no está entre los que podés ver.');
    return;
  }
  FICHA.datos = c;
  $('#fcTitulo').textContent = c.nombre;
  pintarDatosFicha();
  pintarCuentaFicha();
  leerPedidosFicha(turno);
  leerHistorial();
}

function pintarDatosFicha(){
  const c = FICHA.datos;
  for (const [k, sel] of CAMPOS_FICHA) $(sel).value = c[k] ?? '';
  $('#fcComis').checked = !!c.es_comisionista;
  pintarZonaFicha();
  const edita = editaFicha(c);
  $$('#formFc input, #formFc select').forEach((x: any) => { x.disabled = !edita; });
  $('#btnFcGuardar').classList.toggle('oculto', !edita);
  $('#fcSoloLectura').textContent = edita ? ''
    : !puede('cliente','editar') ? 'Sólo lectura: no tenés permiso para editar clientes.'
    : 'Sólo lectura: este cliente no es tuyo. Lo edita su vendedor o un administrador.';
  limpiar('#fcPedidosEnvio');
  $('#formFc').classList.remove('oculto');
}

//  Cuenta, reservas y vendedor: lo mismo que la fila de la lista, con sus
//  mismos botones (que piden sus propios permisos).
function pintarCuentaFicha(){
  if (!FICHA) return;
  const c = CLIENTES.find(x => x.id === FICHA.id) ?? FICHA.fila;
  if (!c){ $('#fcCuenta').innerHTML = ''; return; }
  FICHA.fila = c;
  FICHA.zona = c.zona ?? FICHA.zona;
  $('#fcChips').innerHTML = `${c.es_comisionista ? '<span class="chip c-warn">comisionista</span>'
      : '<span class="chip c-ok">directo</span>'} ${chipCuenta(c)}${
      c.bloqueado_para_reservas ? ' <span class="chip c-bad">bloqueado para reservas</span>' : ''}`;
  const veCuenta = puede('cliente','ver_saldo') || puede('cliente','limite_credito');
  $('#fcCuenta').innerHTML = `
    <div class="grid g3">
      <div><div class="hint">Cuenta corriente</div>${chipCuenta(c)}
        <div id="fcSaldo" class="hint"></div>
        ${veCuenta ? '<button class="b b-sec" type="button" id="fcIrCuenta" style="margin-top:0.353rem">Ver su cuenta</button>' : ''}</div>
      <div><div class="hint">Reservas</div>${celdaReservas(c)}</div>
      <div><div class="hint">Vendedor</div>${celdaVendedor(c)}</div>
    </div>`;
  if (veCuenta) $('#fcIrCuenta').onclick = () => irACuenta(FICHA.id);
  leerSaldo();
}

$('#fcCuenta').onclick = e => {
  const b = el(e.target).closest('.bloqBtn');
  if (b) pedirBloqueo('#fcBloqMsg', b);
};
$('#fcCuenta').onchange = e => reasignar(e, '#fcBloqMsg');

//  El saldo, sólo a quien lo puede ver: sin el permiso la vista da cero sin
//  error, y un cero se leería como «no debe nada» (D83).
async function leerSaldo(){
  if (!FICHA) return;
  const id = FICHA.id;
  if (!puede('cliente','ver_saldo')){ $('#fcSaldo').textContent = ''; return; }
  const { data, error } = await pedir(sb.from('v_cuenta_corriente')
    .select('saldo,disponible,sin_tope').eq('cliente_id', id));
  if (!FICHA || FICHA.id !== id || !$('#fcSaldo')) return;
  if (error){ $('#fcSaldo').textContent = 'No se pudo leer el saldo: ' + error.message; return; }
  const r = (data || [])[0];
  if (!r){ $('#fcSaldo').textContent = ''; return; }
  const saldo = Number(r.saldo || 0);
  $('#fcSaldo').textContent = saldo > 0.005 ? `Debe ${num(saldo)}`
    : saldo < -0.005 ? `A favor ${num(-saldo)}` : 'No debe nada';
}

const CHIP_PED = { activo:'c-pen', finalizado:'c-ok', anulado:'c-bad', borrador:'c-warn' };

//  Sus pedidos, los últimos TOPE_PED_FICHA. El permiso se pregunta antes:
//  sin `pedido.ver` la vista da lista vacía, y «no tiene pedidos» sería falso.
async function leerPedidosFicha(turno: number){
  if (!puede('pedido','ver')){
    $('#tblFcPedidos').innerHTML = '<tr><td colspan="6" class="vacio">Los pedidos no los podés ver.</td></tr>';
    return;
  }
  const { data, error } = await pedir(sb.from('v_pedidos')
    .select('id,codigo,ocurrido_en,metodo_entrega,estado,neto,estado_cobro,saldo,a_cobrar,cobrado')
    .eq('cliente_id', FICHA.id).order('ocurrido_en', { ascending: false }).limit(TOPE_PED_FICHA));
  if (turno !== TURNO_FICHA) return;
  if (error){
    $('#tblFcPedidos').innerHTML = `<tr><td colspan="6" class="vacio">No se pudieron leer los pedidos ` +
      `(${esc(error.message)}). No quiere decir que no tenga ninguno.</td></tr>`;
    return;
  }
  const ps = data || [];
  const conCobros = !!$('#tabPedidos') && !$('#tabPedidos').classList.contains('oculto');
  $('#tblFcPedidos').innerHTML = ps.map((p: any) => `
    <tr><td class="mono">${conCobros
          ? `<a href="#" data-irped="${p.id}"><b>${esc(p.codigo)}</b></a>` : `<b>${esc(p.codigo)}</b>`}</td>
        <td>${esc(fecha(p.ocurrido_en))}</td>
        <td>${esc(p.metodo_entrega || '—')}</td>
        <td><span class="chip ${CHIP_PED[p.estado] || 'c-pen'}">${esc(p.estado)}</span></td>
        <td class="num"><b>${num(Number(p.neto || 0))}</b></td>
        <td>${!Number(p.a_cobrar || 0) && !Number(p.cobrado || 0) ? '<span class="hint">—</span>'
             : `${esc(String(p.estado_cobro || 'sin_cobrar').replace('_', ' '))}${conCobros
               ? ` <button class="b b-sec" type="button" data-ircobro="${p.id}" data-codigo="${esc(p.codigo)}">Cobros</button>` : ''}`}</td></tr>`).join('')
    || `<tr><td colspan="6" class="vacio">${alcance('pedido','ver') === 'propio'
         ? 'No tiene pedidos que puedas ver.' : 'Todavía no tiene pedidos.'}</td></tr>`;
  if (ps.length >= TOPE_PED_FICHA)
    $('#tblFcPedidos').insertAdjacentHTML('beforeend', `<tr><td colspan="6" class="hint">` +
      `<span class="chip c-warn">puede haber más</span> Se muestran los últimos ${TOPE_PED_FICHA}.</td></tr>`);
}

//  Entrar a un pedido: la ficha de la venta (D220), en la pestaña Pedidos.
$('#tblFcPedidos').onclick = e => {
  const a = el(e.target).closest('[data-irped]');
  if (a){
    e.preventDefault();
    $('#tabPedidos').click();
    abrirVenta(Number(a.dataset.irped));
    return;
  }
  const b = el(e.target).closest('[data-ircobro]');
  if (b) irACobros(Number(b.dataset.ircobro), b.dataset.codigo);
};

//  El historial: los cambios de datos los lee quien puede editar a este
//  cliente; los bloqueos, quien puede bloquear (0043, 0099). Sin ninguno de
//  los dos permisos, la base da lista vacía: se dice antes de preguntar.
async function leerHistorial(){
  if (!FICHA) return;
  const id = FICHA.id;
  //  Los cambios de datos los ve quien PUEDE EDITAR a este cliente (no
  //  cualquiera que lo vea: el de la casa lo ve un vendedor, pero no lo edita).
  const veDatos = FICHA.datos ? editaFicha(FICHA.datos) : false;
  if (!veDatos && !puede('cliente','bloquear')){
    $('#fcHist').innerHTML = '<p class="vacio">El historial de este cliente no lo podés ver: ' +
      'lo ve quien lo puede editar.</p>';
    return;
  }
  const [ev, us] = await Promise.all([
    pedir(sb.from('cliente_eventos').select('id,tipo,motivo,datos,usuario_id,ocurrido_en')
      .eq('cliente_id', id).order('ocurrido_en', { ascending: false })),
    pedir(sb.from('usuarios').select('id,nombre'))]);
  if (!FICHA || FICHA.id !== id) return;
  if (ev.error){
    limpiar('#fcHist');
    aviso('#fcHistMsg', 'bad', 'No se pudo leer el historial: ' + ev.error.message +
      '. No quiere decir que no tenga cambios.');
    return;
  }
  //  Sin los nombres, la columna «Quién» dice un número: se avisa.
  if (us.error) aviso('#fcHistMsg', 'warn', 'No se pudieron leer los nombres de quién hizo cada ' +
    'cambio (' + us.error.message + '): se muestra su número.');
  else limpiar('#fcHistMsg');
  const nombres = new Map(((us.data || []) as any[]).map(u => [u.id, u.nombre]));
  const quien = (uid: number | null) => uid == null ? '—' : (nombres.get(uid) ?? `#${uid}`);
  const txt = (v: unknown) => v == null || v === '' ? '(vacío)' : `«${v}»`;
  const linea = (x: any) => {
    if (x.tipo === 'datos')
      return ((x.datos?.cambios || []) as any[]).map(c =>
        `<div>${esc(c.campo)}: ${esc(txt(c.antes))} → ${esc(txt(c.despues))}</div>`).join('')
        + ((x.datos?.pedidos || []).length ? `<div class="hint">También se pasó a ${
            (x.datos.pedidos as any[]).length} pedido(s) en curso.</div>` : '');
    if (x.tipo === 'bloqueo_reservas') return `<div>Bloqueado para reservas: ${esc(x.motivo || '')}</div>`;
    if (x.tipo === 'desbloqueo_reservas') return '<div>Sale de la lista negra de reservas</div>';
    return `<div>${esc(x.tipo)}${x.motivo ? ': ' + esc(x.motivo) : ''}</div>`;
  };
  const filas = (ev.data || []) as any[];
  const parcial = !puede('cliente','bloquear')
    ? '<p class="hint">Los bloqueos para reservas no se ven acá: los ve quien puede bloquear.</p>'
    : !veDatos ? '<p class="hint">Se ven sólo los bloqueos: los cambios de datos los ve quien puede editar al cliente.</p>' : '';
  $('#fcHist').innerHTML = parcial + (filas.length
    ? `<div class="tw"><table><thead><tr><th>Cuándo</th><th>Quién</th><th>Qué</th></tr></thead><tbody>${
        filas.map(x => `<tr><td>${esc(fecha(x.ocurrido_en))}</td><td>${esc(quien(x.usuario_id))}</td>
          <td>${linea(x)}</td></tr>`).join('')}</tbody></table></div>`
    : '<p class="vacio">Todavía no hay cambios anotados.</p>');
}

//  Lo cambiado respecto de lo que se abrió.
function cambiosFicha(){
  const c = FICHA.datos;
  const d: Record<string, unknown> = {};
  for (const [k, sel] of CAMPOS_FICHA){
    const v = ($(sel).value || '').trim();
    if (v !== String(c[k] ?? '').trim()) d[k] = v;
  }
  const zona = $('#fcZona').value ? Number($('#fcZona').value) : null;
  if (zona !== (c.zona_id ?? null)) d.zona_id = zona;
  if ($('#fcComis').checked !== !!c.es_comisionista) d.es_comisionista = $('#fcComis').checked;
  return d;
}

$('#formFc').onsubmit = e => { e.preventDefault(); guardarFicha(null); };

async function guardarFicha(pedidos: number[] | null){
  limpiar('#fcGuardarMsg');
  if (!FICHA?.datos) return;
  //  Con la pregunta abierta se manda lo que hay escrito ahora: la base
  //  vuelve a mirar todo (y si ya no hay datos de envío cambiados, lo dice).
  const d = cambiosFicha();
  if (pedidos == null) limpiar('#fcPedidosEnvio');
  if (Object.keys(d).length === 0){
    aviso('#fcGuardarMsg', 'ok', 'No cambiaste nada.');
    return;
  }
  //  Los dos botones que guardan (el de abajo y el de la pregunta) se
  //  apagan mientras tanto: un doble clic no manda dos veces.
  const btns = [$('#btnFcGuardar'), $('#fcEnvOk')].filter(Boolean);
  btns.forEach((b: any) => { b.disabled = true; });
  const id = FICHA.id;
  const { data, error } = await rpc('editar_cliente',
    { p_cliente_id: id, p_datos: d as any, ...(pedidos == null ? {} : { p_pedidos: pedidos }) });
  btns.forEach((b: any) => { b.disabled = false; });
  if (!FICHA || FICHA.id !== id) return;
  //  Si la base no contestó, quizá quedó guardado (D92): lo tecleado se queda.
  if (noContesto(error)){
    aviso('#fcGuardarMsg', 'warn', error.message + ' No se sabe si quedó guardado: volvé a la lista, ' +
      'entrá de nuevo al cliente y fijate antes de volver a guardar.');
    return;
  }
  if (error){ aviso('#fcGuardarMsg', 'bad', error.message); return; }
  const r = (data ?? {}) as any;
  if (r.preguntar){
    pintarPregunta(r);
    return;
  }
  limpiar('#fcPedidosEnvio');
  const avisos: string[] = r.avisos ?? [];
  await cargarClientes();
  if (!FICHA || FICHA.id !== id) return;
  await abrirFicha(id);
  avisoHtml('#fcGuardarMsg', avisos.length ? 'warn' : 'ok',
    esc(r.mensaje ?? 'Cliente guardado.') + avisos.map(a => '<br>' + esc(a)).join(''));
}

//  La pregunta: a qué pedidos en curso se les pasan los datos de envío
//  nuevos. Arrancan marcados los que tienen la dirección vieja del cliente
//  y no están en la calle.
function pintarPregunta(r: any){
  const ps = (r.pedidos || []) as any[];
  $('#fcPedidosEnvio').innerHTML = `<div class="confirmar">
    <div class="conf-tit">¿Cambiar también los pedidos en curso?</div>
    <p class="conf-txt">${esc(r.mensaje)}</p>
    ${ps.map(p => `<label style="display:block;margin:0.235rem 0"><input type="checkbox" data-envped="${p.id}"${
        p.como_el_cliente && p.vuelta !== 'en_calle' ? ' checked' : ''}>
      <b class="mono">${esc(p.codigo)}</b> — ${esc(p.direccion || 'sin dirección')}${
        p.barrio ? ', ' + esc(p.barrio) : ''}${p.zona ? ' (' + esc(p.zona) + ')' : ''}${
        p.vuelta === 'en_calle' ? ' <span class="chip c-bad">en la calle</span>'
        : p.vuelta === 'armada' ? ' <span class="chip c-warn">en una vuelta armada</span>' : ''}${
        !p.como_el_cliente ? ' <span class="chip">ya tenía otra dirección</span>' : ''}</label>`).join('')}
    <div class="fila-acc" style="justify-content:flex-start;margin-top:0.471rem">
      <button class="b b-pri" type="button" id="fcEnvOk">Guardar</button>
      <button class="b b-sec" type="button" id="fcEnvNo">Volver a editar</button>
    </div></div>`;
  //  Mientras se pregunta, el botón de abajo se esconde: hay uno solo que guarda.
  $('#btnFcGuardar').classList.add('oculto');
  $('#fcEnvNo').onclick = () => { limpiar('#fcPedidosEnvio'); $('#btnFcGuardar').classList.remove('oculto'); };
  $('#fcEnvOk').onclick = () => guardarFicha(
    [...$$('#fcPedidosEnvio [data-envped]')].filter((x: any) => x.checked).map((x: any) => Number(x.dataset.envped)));
}
